/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_exponential_histogram.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts histogram-like values to an exponential histogram.
 *
 * @example
 * FROM histogram_standard_index
 *  | WHERE STARTS_WITH(instance, "hand-rolled")
 *  | EVAL converted = to_exponential_histogram(responseTime)
 *  | SORT instance
 *  | KEEP responseTime, converted
 * ;
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_exponential_histogram',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'exponential_histogram',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'exponential_histogram',
    },
    {
      params: [
        {
          name: 'field',
          type: 'histogram',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'exponential_histogram',
    },
    {
      params: [
        {
          name: 'field',
          type: 'tdigest',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'exponential_histogram',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
